import { Chip } from '@mui/material';
import React from 'react';

const YellowChip = ({ title }) => {
  return (
    <Chip
      label={title}
      size="small"
      style={{
        color: '#847500',
        fontSize: '10px',
        backgroundColor: '#FDF6D0',
        fontWeight: 'bold',
      }}
    />
  );
};

export default YellowChip;
